export const SITE_NAME = 'ВР-Страйкбол';
export const SUPPORT_EMAIL = 'info@tehnostrike.ru';
export const LICENSE_MAIL_SUBJECT = 'Продление лицензии «ВР-Страйкбол»';
export const LICENSE_MAIL_BODY =
  'Здравствуйте!\n' +
  'На моем аккаунте {login} (номер телефона: {phone}) скоро истекает лицензия.\n' +
  'Прошу продлить её. Готов предоставить дополнительную информацию при необходимости.';

export const TECHNOCOINS_MAIL_SUBJECT = 'Покупка пакета Технокоинов «ВР-Страйкбол»';
export const TECHNOCOINS_MAIL_BODY =
  'Здравствуйте!\n' +
  'Прошу оформить покупку пакета Технокоинов для клуба «{clubName}» (аккаунт: {login}).\n\n' +
  'Выбранный пакет:\n' +
  '— Количество: {technocoins} Ŧ\n' +
  '— Стоимость: {amountRubles} ₽\n\n' +
  'Готов предоставить дополнительную информацию при необходимости.';
